export default function(value: string) {
  return value
    .split(' ')
    .map(item => item[0])
    .slice(0, 2)
    .join('')
    .toUpperCase();
}
